import { BUILD_ENV } from '@/config/build-env';
function envFlagIsTrue(value) {
    return value === '1' || value.toLowerCase() === 'true';
}
/**
 * SockJS + STOMP (team chat, session force-logout, break supervisor events).
 * Off by default — set `ENABLE_STOMP_WS=1` in `.env` and rebuild to enable `/websocket/app`.
 */
export const STOMP_WS_ENABLED = envFlagIsTrue(BUILD_ENV.ENABLE_STOMP_WS);
